import { ReactComponent as EditIcon } from '../../icons/edit.svg'
import { ReactComponent as EditBlueIcon } from '../../icons/edit_blue.svg'
import { ReactComponent as AddIcon } from '../../icons/add.svg'
import { ReactComponent as DeleteIcon }  from '../../icons/delete.svg'
import { ReactComponent as RightIcon } from '../../icons/right.svg'
import { ReactComponent as LeftIcon } from '../../icons/left.svg'
import { ReactComponent as DownIcon } from '../../icons/down.svg'
import { ReactComponent as CheckIcon } from '../../icons/check.svg'
import { ReactComponent as CloseIcon } from '../../icons/close.svg'
import { ReactComponent as CalendarIcon } from '../../icons/calendar.svg'
import { ReactComponent as UsersIcon } from '../../icons/users.svg'
import { ReactComponent as HourglassIcon } from '../../icons/hourglass.svg'
import { ReactComponent as HourglassBlueIcon } from '../../icons/hourglass_blue.svg'
import { ReactComponent as UserIcon } from '../../icons/user.svg'
import { ReactComponent as HamburgerIcon } from '../../icons/hamburger.svg'
import { ReactComponent as RemoveUserIcon } from '../../icons/remove_user.svg'
import { ReactComponent as AddressIcon } from '../../icons/address.svg'
import { ReactComponent as ClockIcon } from '../../icons/clock.svg'
import { ReactComponent as ArchiveIcon } from '../../icons/archive.svg'
import { ReactComponent as ArchiveWhiteIcon } from '../../icons/archive_white.svg'
import { ReactComponent as RestoreIcon } from '../../icons/restore.svg'
import { ReactComponent as AddWhiteIcon } from '../../icons/add_white.svg'
import { ReactComponent as EyeIcon } from '../../icons/eye.svg'
import { ReactComponent as UsersBlue } from '../../icons/users_blue.svg'
import { ReactComponent as StatusIcon } from '../../icons/status.svg'
import { ReactComponent as UnarchiveIcon } from '../../icons/unarchive.svg'
import { ReactComponent as ShareIcon } from '../../icons/share.svg'
import { ReactComponent as InfoIcon } from '../../icons/info.svg'
import { ReactComponent as ToDoIcon } from '../../icons/to-do-list.svg'
import { Tooltip } from '@mui/material'

const IconButton = ({icon, width, height, onClick, extraStyling, disabled, type='button', tooltip, tooltipPlacement}) => {

  const iconComponents = {
    'edit': EditIcon,
    'edit_blue': EditBlueIcon,
    'add': AddIcon,
    'add_white': AddWhiteIcon,
    'delete': DeleteIcon,
    'left': LeftIcon,
    'right': RightIcon,
    'down': DownIcon,
    'check': CheckIcon,
    'close': CloseIcon,
    'calendar': CalendarIcon,
    'users': UsersIcon,
    'hourglass': HourglassIcon,
    'user': UserIcon,
    'hamburger': HamburgerIcon,
    'remove_user': RemoveUserIcon,
    'address': AddressIcon,
    'clock': ClockIcon,
    'archive': ArchiveIcon,
    'archive_white': ArchiveWhiteIcon,
    'unarchive': UnarchiveIcon,
    'restore': RestoreIcon,
    'eye': EyeIcon,
    'users_blue': UsersBlue,
    'hourglass_blue': HourglassBlueIcon,
    'status': StatusIcon,
    'share': ShareIcon,
    'info': InfoIcon,
    'todo': ToDoIcon,
  }

  const IconComponent = iconComponents[icon];

  const buttonStyle = {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
  };

  const accessibleLabel = tooltip || icon.replace(/_/g, ' ');

  return (
    <Tooltip title={tooltip || ''} placement={tooltipPlacement || 'bottom'} arrow>
      <button
        className={"center-content-v " + extraStyling}
        style={buttonStyle}
        onClick={onClick}
        disabled={disabled}
        type={type}
        aria-label={accessibleLabel}
      >
      <IconComponent style={{width: width, height: height}}/>
      </button>
    </Tooltip>
  );
}

export default IconButton;